<div class="coin_details zindex h-100">
  <div class="card trade_card h-100 position-relative">

    <div class="card-header d-flex justify-content-between align-items-center py-2 border-bottom border-secondary">
      <h5 class="mb-0 text-white">Bot Opportunity</h5>
      <button class="btn d-flex align-items-center p-1 ps-2 pe-3 rounded border border-secondary"
        style="background-color: #1e2026;" (click)="downloadExcel('')" [disabled]="isDownloading">
        <div class="rounded me-2 d-flex align-items-center justify-content-center"
          style="background-color: rgba(56, 189, 248, 0.1); width: 28px; height: 28px;">
          <i class="bi bi-file-earmark-arrow-down" style="color: #38bdf8;"></i>
        </div>
        <div class="text-start lh-1">
          <p class="mb-0 text-secondary" style="font-size: 0.6rem; text-transform: uppercase;">Action</p>
          <span class="text-white" style="font-size: 0.75rem;">CSV Export</span>
        </div>
      </button>
    </div>

    <div class="card-body p-0 position-relative" style="overflow: hidden;">

      <!-- <div class="floating-investment-card p-3 rounded shadow-lg" *ngIf="selectedPair"
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 50; background: #1e2026; border: 1px solid #38bdf8; width: 280px;">

        <div class="d-flex justify-content-between align-items-center mb-3 border-bottom border-secondary pb-2">
          <h6 class="m-0 text-white">Bot: <span class="text-success">{{selectedPair.symbol}}</span></h6>
          <button class="btn btn-sm btn-link text-secondary p-0" (click)="selectedPair = null">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="mb-3">
          <label class="small text-secondary mb-1">Investment Amount</label>
          <input class="form-control bg-dark text-white border-secondary" type="text" [ngModel]="investmentAmount"
            (input)="handleTradeChange($event)">
        </div>

        <button class="btn btn-success w-100" (click)="createBot()" [disabled]="submitLoader">Start Strategy</button>
      </div> -->

      <!-- <div class="table-wrapper h-100" [style.opacity]="selectedPair ? '0.3' : '1'"> -->
      <div class="table-wrapper h-100" [style.opacity]="'1'">
        <table class="pair-table">
          <thead>
            <tr>
              <th class="ps-3">Pair</th>
              <th class="text-end">Price</th>
              <th class="text-end">Vol (USDT)</th>
              <th class="text-end">5m %</th>
              <th class="text-end">Cur %</th>
              <th class="text-end pe-3">Found At</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pair of topGainers | textFilter: 'tikerRoot': searchPair; trackBy: trackBySymbol"
              (click)="changePair(pair)">

              <td class="ps-3">
                <span [ngClass]="pair.isProfit ? 'text-success' : 'text-white'">{{ pair.symbol }}</span>
              </td>

              <td class="text-end">{{ nFormatter(truncateDecimals(pair.price, 2)) }}</td>
              <td class="text-end">{{ nFormatter(truncateDecimals(pair.volumeUSDT, 2)) }}</td>
              <td class="text-end">{{ nFormatter(truncateDecimals(pair.change, 2)) }}</td>

              <td class="text-end">
                <span [ngClass]="pair.currentPercentage > 0 ? 'text-success' : 'text-danger'">
                  {{ nFormatter(truncateDecimals(pair.currentPercentage, 4)) }}
                </span>
              </td>

              <td class="text-end text-secondary pe-3">
                {{ dateTimeFormat(pair.createdAt) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>